module.exports = __webpack_public_path__ + "static/media/Vynca-web-thumb.8112c42d.png";